import { render, staticRenderFns } from "./SupportPRS.vue?vue&type=template&id=8e2ee644&scoped=true&"
import script from "./SupportPRS.vue?vue&type=script&lang=js&"
export * from "./SupportPRS.vue?vue&type=script&lang=js&"
import style0 from "./SupportPRS.vue?vue&type=style&index=0&id=8e2ee644&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2ee644",
  null
  
)

export default component.exports